// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Oewi","messages":"Chat_messages__1miZx","dateDivider":"Chat_dateDivider__1KnRP"};